










































































import Vue from 'vue';
import { ImageSrc } from '@/store/types';
import ImageModal from '@/components/ImageModal/index.vue';

export default Vue.extend({
  name: 'ProjectDisplay',
  components: { ImageModal },
  data() {
    return {
      dialogm1: '',
      dialog: false
    };
  },
  props: {
    chosenImage: {
      type: Object as () => ImageSrc,
      required: true
    },
    images: {
      type: Array as () => ImageSrc[] // https://stackoverflow.com/questions/41139763/how-to-declare-a-fixed-length-array-in-typescript
    },
    title: {
      type: String
    }
  },
  methods: {
    setNext(): void {
      this.$emit('setNext');
    },
    setPrevious(): void {
      this.$emit('setPrevious');
    },
    setChosenId(id: string): void {
      this.$emit('setChosenId', id);
    }
  }
});
